/**
 * Auth0 redirect configuration.
 *
 * Login callback:
 *   REACT_APP_REDIRECT_URI: full URL override
 *   REACT_APP_REDIRECT_PATH: path suffix (default /redirecting)
 *
 * Logout returnTo:
 *   REACT_APP_LOGOUT_REDIRECT_URI: full URL override
 *   REACT_APP_LOGOUT_REDIRECT_PATH: path suffix (default /)
 *
 * Multiple domains: both use current origin when env vars are unset.
 * Add each domain+path to Auth0 Allowed Callback URLs and Allowed Logout URLs.
 */
const rawPath = process.env.REACT_APP_REDIRECT_PATH || "/redirecting";
export const AUTH_REDIRECT_PATH = rawPath.startsWith("/")
  ? rawPath
  : `/${rawPath}`;

const rawLogoutPath =
  process.env.REACT_APP_LOGOUT_REDIRECT_PATH ?? "/";
export const LOGOUT_REDIRECT_PATH = rawLogoutPath.startsWith("/")
  ? rawLogoutPath
  : `/${rawLogoutPath}`;

function getOrigin(): string {
  return globalThis.location == null
    ? "http://localhost:3000"
    : globalThis.location.origin;
}

export function getAuthRedirectUri(): string {
  return `${getOrigin()}${AUTH_REDIRECT_PATH}`;
}

export function getLogoutRedirectUri(): string {
  return `${getOrigin()}${LOGOUT_REDIRECT_PATH}`;
}
